import { EsUserAccessibilityToService } from 'src/app/core/models/shared/EsUserAccessibilityToService';

export class ServiceAccessResult {
  isRedirect: boolean;
  url: string;
  state: EsUserAccessibilityToService;
}
